import React from 'react';
import { base } from '../../helper/base-helper'
import { Container, Header, Icon, Divider, Menu } from 'semantic-ui-react';

import NotificationObserver from './NotificationObserver';
import NotificationUserList from './NotificationUserList';
import NotificationSettings from './NotificationSettings';

class NotificationCentre extends React.Component {

  constructor() {
    super();

    this.state = {
      loading: true,
      channels: {},
      actions: {},
      userNotifications: {},
      observedChanges: {},
      recentChanges: {},
      allChangesPagination: 10,
      activeItem: 'yourNotifications'
    };
  }

  componentDidMount() {
    this.fetchLogItems('recentChanges', this.state.allChangesPagination);
    this.baseSyncs();
  }

  componentWillUnmount() {
    base.removeBinding(this.chanRef);
    base.removeBinding(this.acyRef);
    base.removeBinding(this.notiRef);
    console.log('i unmount');
  }

  removeNotification = (key) => {
    const userNotifications = {...this.state.userNotifications}
    delete userNotifications[key];
    console.log(userNotifications);
    this.setState({userNotifications})
  };


  baseSyncs = () => {
    this.chanRef = base.syncState('channels', {
      context: this,
      state: 'channels'
    });
    this.acyRef = base.syncState('actions', {
      context: this,
      state: 'actions'
    });
    this.notiRef = base.syncState(`_usernotifications/${this.props.user.uid}`,{
      context: this,
      state: 'userNotifications'
    });
  }

  fetchLogItems = (stateRef, limit) => {
    let tmpObj = {};
    this.setState({loading: true});
    base.fetch('_changelogs', {
      context: this,
      queries: {
        orderByKey: true,
        limitToFirst: limit
      },
      then(data) {
        tmpObj[stateRef] = {...data}
        tmpObj.loading = false;
        this.setState({...tmpObj})
      },
      catch(err){console.error(err)}
    });
  };

  handleTabClick = (e, { name }) => {
    this.setState({activeItem: name});
  }

  render() {
    const { activeItem } = this.state;

    return (
      <Container text>
        <Header as='h2'>
          <Icon name='flag' />
          <Header.Content>
            Notification Centre
            <Header.Subheader>
              See what has changed in your observed actions and platform wide.
              Manage your notification settings here, too.
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Divider />

        <Menu tabular attached='top'>
        <Menu.Item name='yourNotifications' active={activeItem === 'yourNotifications'} onClick={this.handleTabClick} >
          <Icon name='user' />
          Your Notifications
        </Menu.Item>
        <Menu.Item name='settingsTab' active={activeItem === 'settingsTab'} onClick={this.handleTabClick} >
          <Icon name='settings' />
          Settings
        </Menu.Item>
        </Menu>
        {
          (this.state.activeItem === 'yourNotifications')
          ? <NotificationUserList loading={this.state.loading} />
          : <NotificationSettings
            actions={this.state.actions}
            channels={this.state.channels}
            loading={this.state.loading}
            removeNotification={this.removeNotification}
            user={this.props.user}
            userNotifications={this.state.userNotifications}
            />
        }
        <Divider section />

        <NotificationObserver
          recentChanges={this.state.recentChanges}
          channels={this.state.channels}
          loading={this.state.loading}
          clickCallback={() => this.fetchLogItems('recentChanges', (this.state.allChangesPagination + 10))}
         />

      </Container>
    );
  }

}

export default NotificationCentre;



// WEBPACK FOOTER //
// ./src/components/protected/NotificationCentre.js